import request from '../api';

// 获取多媒体类型
export function getMediaType() {
  return request.get('/app/mediaPlatform/getMediaType');
}

// 检查多媒体状态
export function checkMedia(data) {
  return request.post('/app/mediaPlatform/checkMedia', data);
}

// 获取已绑定的多媒体账号
export function getBindMedia() {
  return request.get('/app/mediaPlatform/getBindMedia');
}

// 绑定多媒体平台
export function addMedia(data) {
  return request.post('/app/mediaPlatform/addMedia', data);
}

// id查询多媒体
export function updateMedia(id) {
  return request.get(`/app/mediaPlatform/getMediaById/${id}`);
}

// 发布媒体
export function release(data) {
  return request.post('/app/mediaPlatformRelease/release', data);
}

// 获取发布平台
export function planGeneratedDetailGetReleasePlatform(generateId) {
  return request.get(`/app/planGeneratedDetail/getReleasePlatform/${generateId}`);
}

// 解除绑定
export function unBindMedia(id) {
  return request.get(`/app/mediaPlatform/unBindMedia/${id}`);
}

// 4、获取状态
/**
 * 
 * @param data 
 * STATE_OFF = -1  # 未启动
STATE_LOGIN_SUCCESS = 0  # 登录成功
STATE_WAITING_QRCODE = 1  # 等待打开抖音获取二维码
STATE_WAITING_SCAN_QRCODE = 2  # 等待用户扫码中
STATE_REQUIRE_SMS = 3  # 需要短信验证码
STATE_COMMIT_SMS = 4  # 提交短信给抖音中
 * @returns 
 */
export function getState(data) {
  let baseURL = process.env.VUE_APP_API_MEDIUM_URL;
  return request({
    baseURL,
    url: '/get_state',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

// 生成二维码
export function getbuildQrcode(data) {
  let baseURL = process.env.VUE_APP_API_MEDIUM_URL;
  return request({
    baseURL,
    url: '/build_qrcode',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

// 3、获取二维码
export function getQrcode(data) {
  let baseURL = process.env.VUE_APP_API_MEDIUM_URL;
  return request({
    baseURL,
    url: '/get_qrcode',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

// 5、提交短信验证码
export function submitSms(data) {
  let baseURL = process.env.VUE_APP_API_MEDIUM_URL;
  return request({
    baseURL,
    url: '/submit_sms',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

// 6、上传视频
export function uploadVideo(data) {
  let baseURL = process.env.VUE_APP_API_MEDIUM_URL;
  return request({
    baseURL,
    url: '/upload_video',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}

// 7、检查状态
export function checkCookie(data) {
  let baseURL = process.env.VUE_APP_API_MEDIUM_URL;
  return request({
    baseURL,
    url: '/check_cookie',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
